module.exports = __webpack_public_path__ + "img/header_logo.6dedfe30.png";